module.exports = __webpack_public_path__ + "img/f_and_p_text.61dc70e5.png";